import { useMemo, type CSSProperties } from 'react';
import { useResolvedTheme } from '@/theme/theme';
import { miscSize, miscUri, type MiscName } from './misc';
import type { ArtTheme } from './covers/kit';

/** One piece of small art (trophy, medals, gift, shield, logo, empty states…), follows the theme. Decorative. */
export function MiscArt({
  name,
  size,
  width,
  className,
  style,
  theme,
}: {
  name: MiscName;
  /** square size (icons) */
  size?: number;
  /** width for the 320×240 illustrations (height keeps the aspect) */
  width?: number;
  className?: string;
  style?: CSSProperties;
  theme?: ArtTheme;
}) {
  const current = useResolvedTheme();
  const t = theme ?? current;
  const src = useMemo(() => miscUri(name, t), [name, t]);
  const { w, h } = miscSize(name);
  const W = width ?? size ?? w;
  const H = width ? Math.round((width * h) / w) : (size ?? h);
  return <img src={src} alt="" aria-hidden="true" draggable={false} width={W} height={H} className={className} style={{ display: 'block', flex: 'none', ...style }} />;
}
